/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Create, Edit, SimpleForm, useTranslate } from 'react-admin';
import LicenseForm from './LicenseForm';
import licenseStatus from '../../enums/license-status.enum';

const LicenseDetail = (props) => {
  const { actionType } = props;
  const translate = useTranslate();
  const statusLabel = translate('custom.general.status');
  const nameLabel = translate('custom.general.name');
  const courseLabel = translate('custom.courses.title');
  return (
    <>
      {actionType === 'edit' ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Edit {...props}>
          <SimpleForm>
            <LicenseForm
              status={licenseStatus}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              courseLabel={courseLabel}
            />
          </SimpleForm>
        </Edit>
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Create {...props}>
          <SimpleForm>
            <LicenseForm
              status={licenseStatus}
              statusLabel={statusLabel}
              nameLabel={nameLabel}
              courseLabel={courseLabel}
            />
          </SimpleForm>
        </Create>
      )}
    </>
  );
};

LicenseDetail.propTypes = {
  actionType: PropTypes.string,
  basePath: PropTypes.string.isRequired,
};

LicenseDetail.defaultProps = {
  actionType: 'create',
};

export default LicenseDetail;
